import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export interface TutorialProps {
  id: number;
  label: string;
  url: string;
}

interface Props {
  value: TutorialProps | null;
  setValue: React.Dispatch<React.SetStateAction<TutorialProps | null>>;
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
}

export default function HowTo({ value, setValue, inputValue, setInputValue }: Props) {
  return (
    <Autocomplete
      disablePortal
      value={value}
      onChange={(_: any, newValue: TutorialProps | null) => {
        setValue(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => {
        setInputValue(newInputValue);
      }}
      id="how-to-autocomplete"
      options={options}
      sx={{ width: 500 }}
      renderInput={(params) => <TextField {...params} label="How To" />}
    />
  );
}

const options: TutorialProps[] = [
  {
    id: 1,
    label: 'Log in to KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Log_in_to_WMS_2023__r2dHmZ5CRPCvoEGi0_g3xw',
  },
  {
    id: 2,
    label: 'Sign up for KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Sign_up_for_WMS_2023__91YSWBQzTtWkHFO7Mdj7JA',
  },
  {
    id: 3,
    label: 'Change/Recover password in KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Recover_account_for_WMS_2023__mGWxVES_Q-aQGzgbrvfYRg',
  },
  {
    id: 4,
    label: 'Use Dashboard in KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Use_Dashboard_in_WMS_2023__X1B5E3VzQ2ytrZ37s-YJHg',
  },
  {
    id: 5,
    label: 'Start/Stop a service KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Start__Stop_a_service_in_WMS_2023__GvqAGNyiS2mpRBDHZ0G4tQ',
  },
  {
    id: 6,
    label: 'Restart a service in KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Restart_a_service_in_WMS_2023__hCdlcp4nSr2DIUvmlMWa3g',
  },
  {
    id: 7,
    label: 'Use Service Monitor table toolbar in KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Use_Service_Monitor_toolbar_in_WMS_2023__4v5VFsOOToGk6njwvS0PQg',
  },
  {
    id: 8,
    label: 'Assign a category for a service in KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Assign_a_category_for_a_service_in_WMS_2023__-H1_2ATcTmKSo5uzj55Ejw',
  },
  {
    id: 9,
    label: 'Dismiss one or multiple logs for a service in KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Dismiss_one_or_multiple_logs_for_a_service_in_WMS_2023__0mboyC_TQZazVWVxETESPQ',
  },
  {
    id: 10,
    label: 'Perform a necessary option on a service error in KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Perform_a_necessary_action_on_a_service_error_In_WMS_2023__0PLA80_MT-Wvrb9P-n7UeQ',
  },
  {
    id: 11,
    label: 'Set up monitor options for a service in KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Set_up_monitor_options_for_a_service_in_WMS_2023__VIc385TtShmhrflzotkq1g',
  },
  {
    id: 12,
    label: "Set up monitor options for a service's context in KAP WMS",
    url: 'https://scribehow.com/embed/How_To_Set_up_monitor_options_for_a_services_context_in_WMS_2023__EYtyUjMoTmW2NQQvBEPDWw',
  },
  {
    id: 13,
    label: 'Set up Conveyor Monitor in full screen mode in KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Set_up_Conveyor_Monitor_in_full_screen__mdat0EMeTTOJqLIU9Hou1g',
  },
  {
    id: 14,
    label: 'Filter Conveyor Monitor by shipper name in KAP WMS',
    url: 'https://scribehow.com/embed/How_To_Filter_Conveyor_Monitor_by_shipper_name_in_WMS_2023__L7ys33NWR_e5BKP-Nf1LUQ',
  },
  {
    id: 15,
    label: 'How To: Receive Alerts when a service stopped unexpectedly',
    url: 'https://scribehow.com/embed/How_To_Receive_Alerts_when_a_service_stopped_unexpectedly__zLF1xHuLT_ScCBzhzbRzqA',
  },
  {
    id: 16,
    label: 'How To: Receive Alerts for a Service Context',
    url: 'https://scribehow.com/embed/How_To_Receive_Alerts_for_a_Service_Context__g6WrwCjoRuOoAF52PV-vkw',
  },
  {
    id: 17,
    label: 'How To: Do closeout from Start to FINISH',
    url: 'https://scribehow.com/embed/Procedure_how_to_process_a_close_out_from_start_to_finish__sW2ZoMTjR42n3FAe9Kmlfw',
  },
  {
    id: 18,
    label: 'How To: Find Order Status',
    url: 'https://scribehow.com/embed/How_to_Find_Order_Status_from_KAP_WMS__-MP2hHTRTPa19ZOX-yg4UA',
  },
  {
    id: 19,
    label: 'How To: View Fitment Lines by SKU',
    url: 'https://scribehow.com/embed/How_to_Search_Fitment_Lines_By_SKU_in_KAP_WMS__QmHPy_TfQO23iFIhXWs9YA',
  },
  {
    id: 19,
    label: 'How To: View Ninety Day Sales by SKU',
    url: 'https://scribehow.com/embed/How_to_Check_90_Day_Sales_By_SKU_in_KAP_WMS__hvDlCOxRSAO3dvPikV07-g',
  },
];
